"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var _1 = require("./");
var ResultAsync = /** @class */ (function () {
    function ResultAsync(res) {
        this._promise = res;
    }
    ResultAsync.fromPromise = function (promise, errorFn) {
        var newPromise = promise.then(function (value) { return new _1.Ok(value); });
        if (errorFn) {
            newPromise = newPromise["catch"](function (e) { return new _1.Err(errorFn(e)); });
            if (typeof process !== 'object' ||
                (process.env.NODE_ENV !== 'test' && process.env.NODE_ENV !== 'production')) {
                var yellowColor = '\x1b[33m%s\x1b[0m';
                var warning = [
                    '[neverthrow]',
                    '`fromPromise` called without a promise rejection handler',
                    'Ensure that you are catching promise rejections yourself, or pass a second argument to `fromPromsie` to convert a caught exception into an `Err` instance',
                ].join(' - ');
                console.warn(yellowColor, warning);
            }
        }
        return new ResultAsync(newPromise);
    };
    ResultAsync.prototype.map = function (f) {
        var _this = this;
        return new ResultAsync(this._promise.then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (res.isErr()) {
                            return [2 /*return*/, new _1.Err(res.error)];
                        }
                        _a = _1.Ok.bind;
                        return [4 /*yield*/, f(res.value)];
                    case 1: return [2 /*return*/, new (_a.apply(_1.Ok, [void 0, _b.sent()]))()];
                }
            });
        }); }));
    };
    ResultAsync.prototype.mapErr = function (f) {
        var _this = this;
        return new ResultAsync(this._promise.then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (res.isOk()) {
                            return [2 /*return*/, new _1.Ok(res.value)];
                        }
                        _a = _1.Err.bind;
                        return [4 /*yield*/, f(res.error)];
                    case 1: return [2 /*return*/, new (_a.apply(_1.Err, [void 0, _b.sent()]))()];
                }
            });
        }); }));
    };
    ResultAsync.prototype.andThen = function (f) {
        return new ResultAsync(this._promise.then(function (res) {
            if (res.isErr()) {
                return new _1.Err(res.error);
            }
            var newValue = f(res.value);
            return newValue instanceof ResultAsync ? newValue._promise : newValue;
        }));
    };
    ResultAsync.prototype.match = function (ok, _err) {
        return this._promise.then(function (res) { return res.match(ok, _err); });
    };
    // Makes ResultAsync awaitable
    ResultAsync.prototype.then = function (successCallback) {
        return this._promise.then(successCallback);
    };
    return ResultAsync;
}());
exports.ResultAsync = ResultAsync;
exports.okAsync = function (value) {
    return new ResultAsync(Promise.resolve(new _1.Ok(value)));
};
exports.errAsync = function (err) {
    return new ResultAsync(Promise.resolve(new _1.Err(err)));
};
